<script lang="ts">
	import { useGroup } from "@components/utils/group.store";
	import { onMount, type Snippet } from "svelte";

	const {
		link: propLink = "",
		objectID = "",
		index = 0,
		children
	} = $props<{
		children?: Snippet;
		link?: string;
		objectID?: string;
		index?: number;
	}>();

	// Create a local variable that we can modify
	let currentLink = $state(propLink);

	const { setValue } = useGroup<{
		link: string;
		objectID: string;
		index: number;
	}>("socialShareDrawer");

	onMount(() => {
		//use current page if nothing is
		if (!currentLink) {
			currentLink = document.location.href;
		}
	});
</script>

<button
	onclick={() => {
		setValue({
			link: currentLink,
			objectID,
			index
		});
	}}
>
	{#if children}
		{@render children()}
	{:else}
		Delen
	{/if}
</button>
